export default {
  // 错误消息
  errors: {
    failedToUploadLogo: "Failed to upload logo",
  },
  
  // 表单验证消息
  validation: {
    organizationNameRequired: "Please enter an organization name",
    nameTooLong: "Name should not exceed 256 characters.",
  },
  
  // 表单占位符
  placeholders: {
    organizationName: "Organization name",
  },
};
